import { FormValues } from '../components/form/types';
import { CategoryListResponse } from './types/partner';
import { ApiFactoryClassType } from './factory';
import { TranslationValueResponse } from './types/translation';

const category = (factory: ApiFactoryClassType) => ({
    getCategoryList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: string,
    ): Promise<CategoryListResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/category/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createCategory: async (
        categoryObject: FormValues,
    ): Promise<TranslationValueResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/category/create`, factory.getApiHost()),
                {
                    method: 'POST',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(categoryObject),
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default category;
